"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MVC_DURATION_LIMIT = exports.IRR_DURATION_LIMIT = exports.DEFAULT_SOLENOID_VOLTAGE = exports.SprinklerCoverage = exports.SprinklerType = exports.hyperStatusTypes = exports.irrStatusTypes = exports.IrrStatusTypes = void 0;
const Helpers_1 = require("../../Helpers");
var IrrStatusTypes;
(function (IrrStatusTypes) {
    IrrStatusTypes["ONLINE"] = "Online - not irrigating";
    IrrStatusTypes["OFFLINE"] = "Offline";
    IrrStatusTypes["ERROR"] = "Error";
    IrrStatusTypes["IRRIGATING"] = "Irrigating";
    IrrStatusTypes["UNSEEN"] = "Never Seen";
    IrrStatusTypes["DISABLED"] = "Disabled";
    IrrStatusTypes["AREAPAUSED"] = "Paused";
    IrrStatusTypes["AWAITINGPROGRAMME"] = "Programme Pending";
    IrrStatusTypes["LOWERBATTERY"] = "HYPER - Lower Battery";
})(IrrStatusTypes || (exports.IrrStatusTypes = IrrStatusTypes = {}));
exports.irrStatusTypes = [
    { name: 'Online - not irrigating', id: IrrStatusTypes.ONLINE },
    { name: 'Offline', id: IrrStatusTypes.OFFLINE },
    { name: 'Disabled', id: IrrStatusTypes.DISABLED },
    { name: 'Paused', id: IrrStatusTypes.AREAPAUSED },
    { name: 'Error', id: IrrStatusTypes.ERROR },
    { name: 'Irrigating', id: IrrStatusTypes.IRRIGATING },
    { name: 'Never Seen', id: IrrStatusTypes.UNSEEN },
    { name: 'Programme Pending', id: IrrStatusTypes.AWAITINGPROGRAMME },
];
exports.hyperStatusTypes = [{ name: 'HYPER - Lower Battery', id: IrrStatusTypes.LOWERBATTERY }];
var SprinklerType;
(function (SprinklerType) {
    SprinklerType["Senninger 8025"] = "Senninger 8025";
    SprinklerType["Senninger 8025-2ED"] = "Senninger 8025-2ED";
    SprinklerType["Senninger 8025-2RD"] = "Senninger 8025-2RD";
    SprinklerType["Senninger 8025-2SD"] = "Senninger 8025-2SD";
    SprinklerType["Komet K162 (FC)"] = "Komet K162 (FC)";
    SprinklerType["Komet K163 (PC)"] = "Komet K163 (PC)";
    SprinklerType["Sime Hidra (PC)"] = "Sime Hidra (PC)";
    SprinklerType["Senior (FC & PC)"] = "Senior (FC & PC)";
    SprinklerType["K1 (PC)"] = "K1 (PC)";
})(SprinklerType || (exports.SprinklerType = SprinklerType = {}));
var SprinklerCoverage;
(function (SprinklerCoverage) {
    SprinklerCoverage["90 degrees"] = "90";
    SprinklerCoverage["180 degrees"] = "180";
    SprinklerCoverage["270 degrees"] = "270";
    SprinklerCoverage["360 degrees"] = "360";
})(SprinklerCoverage || (exports.SprinklerCoverage = SprinklerCoverage = {}));
exports.DEFAULT_SOLENOID_VOLTAGE = 12;
exports.IRR_DURATION_LIMIT = (0, Helpers_1.numberByteMax)(1); // 255
exports.MVC_DURATION_LIMIT = 1440;
